import * as React from "react";
import PropTypes from "prop-types";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import decisionMakerImage from "../../../Assets/Cloudfigma.svg";
import ContactDetailList from "../../AiLeads/ContactDetailList/ContactDetailList";
import RightSidebar from "../../RightSiderbar/RightSiderbar";
import axios from "axios";
import { APIUrlOne, APIUrlThree, APIUrlToken, APIUrlTwo, getConfidenceScore, GetOktaAuthData, GetUserId, logEvent } from "../../../Utils/Utils";
import IndustryDropdown from "../../AiLeads/IndustrySectorDropdown/Index";
import { toast } from "react-toastify";
import starRed from '../../../Assets/starRed.svg'
import Stargrey from '../../../Assets/Stargrey.png'
import { Box } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import hoveridentifier from "../../../Assets/hoverindentifier.svg"
import moment from "moment";
import MessageModal from "../../MessageModal/MessageModal";
import sortingimg from "../../../Assets/sortingarrow.svg"
import syncsorting from "../../../Assets/syncsorting.svg"
import activeSaleforceLogo from "../../../Assets/activeSaleforceLogo.svg"
import { Modal } from "@mui/material";
import { ClearIcon } from "@mui/x-date-pickers";
import SouthIcon from '@mui/icons-material/South';
import NorthIcon from '@mui/icons-material/North';
import * as XLSX from 'xlsx';
import AddToFavoritePeopleModal from "../../FavoritesList/AddToFavoriteModal/AddToFavoritePeopleModal";
import ProspectRequestModal from "../../RequestUpdateModals/ProspectRequestModal";
import SalesForceMessageModal from "../../MessageModal/SalesForceMessageModal";
function Row({ row, setLoading,
    selectedOuterRows, searchResultList, listPeopleSearchResults, setSearchResultList,
    handleRowSelect }) {

    const [openSidebar, setOpenSidebar] = React.useState(false);
    const [dataShortestPath, setDataShortestPath] = React.useState();
    const loggedInUserId = GetUserId();
    const [userDetails, setUserDeatils] = React.useState();
    const navigate = useNavigate()
    const handleRightsidebar = (event) => {
        logEvent("shortest-path", "JOI");
        const data = {};
        data.source_uid = loggedInUserId;
        data.target_uid = Number(event?.person_id);
        const option = {
            method: "POST",
            headers: {
                "access-control-allow-origin": "*",
                "content-type": "application/json",
                "X-API-Key": APIUrlToken()
            },
            data: data,
            url: `${APIUrlTwo()}/v1/shortest-path`,
        };
        axios(option)
            .then((response) => {
                if (response?.status === 200) {
                    const data = Object.values(response.data);
                    setDataShortestPath(data);
                    setOpenSidebar(true);
                    setUserDeatils(event)
                }
            })
            .catch((err) => {
                toast.error(err?.response?.data?.message);
            });
    };
    const handleFavouriteLead = (row) => {
        const option = {
            method: "POST",
            headers: {
                "access-control-allow-origin": "*",
                "content-type": "application/json",
                "X-API-Key": APIUrlToken()
            },
            data: [row.person_id],
            url: `${APIUrlThree()}/favorites/people/list/add-record?user_id=${GetUserId()}`,
        };
        axios(option)
            .then(async (response) => {
                setLoading(false);
                listPeopleSearchResults(true)
                toast.success(response.data?.message);
                // if (response?.data?.already_existing.length) {
                //     toast.error(response.data.already_existing[0].message);
                // } else {
                //     toast.success(response.data?.message);
                // }
                // toast.success("Prospect added to favorites")
            })
            .catch(() => {
                setLoading(false);
            });
    }
    const handleRemoveFavouriteLead = () => {
        const option = {
            method: "DELETE",
            headers: {
                "access-control-allow-origin": "*",
                "content-type": "application/json",
                "X-API-Key": APIUrlToken()
            },
            url: `${APIUrlThree()}/favorites/delete_favorites_people?user_id=${loggedInUserId}`,
            data: [row?.person_id],
        };
        axios(option)
            .then(async (response) => {
                setLoading(false);
                toast.success("Prospect removed from favorites")
                listPeopleSearchResults(true)
            })
            .catch(() => {
                setLoading(false);
            });
    }

    return (
        <TableRow className="juyds" sx={{ "& > *": { borderBottom: "unset" } }}>
            <>
                <TableCell className="checkbox-row-table-inner checkbox-row-table">
                    <div className="kjhgf">

                        <input
                            type="checkbox"
                            onChange={() => handleRowSelect(row)}
                            checked={selectedOuterRows.some(item => item.person_id === row?.person_id)}
                        />

                    </div>
                </TableCell>
                <TableCell style={{ cursor: 'pointer' }}
                    component="th"
                    scope="row"
                >
                    <>
                        {
                            row?.isfavourites ?
                                <div className="kjhgf" onClick={() => handleRemoveFavouriteLead(row)}>
                                    <img src={starRed} alt="" />
                                </div> :
                                <div className="kjhgf" onClick={() => handleFavouriteLead(row)}>
                                    <img src={Stargrey} alt="" />
                                </div>
                        }
                    </>
                </TableCell>
                <TableCell component="th" scope="row" style={{ cursor: 'pointer' }}>
                    <p className="joi-strength-control">{row?.strengthData?.strength ? row?.strengthData?.strength : "-"}</p>
                </TableCell>
                <TableCell className="Decisions-row-tableName-prospect" align="left" onClick={() => { navigate(`/Profile/${row?.person_id == 0 ? "0" : row?.person_id}`) }} style={{ cursor: 'pointer' }}>

                    <div
                        className={
                            row?.decision_maker === true
                                ? "Decision-maker-user-name"
                                : "Decision-maker-user-noborder create-name-img"
                        }
                    >
                        <img
                            className={
                                row?.suspect_status === null
                                    ? "hide-image"
                                    : row?.journey_status === "project created"
                                        ? "decisionMakerImageAi-Decisionmaker-green"
                                        : "decisionMakerImageAi-Decisionmaker"
                            }
                            // src={decisionMakerImage}
                            src={row?.journey_status === "project created" ? activeSaleforceLogo : decisionMakerImage}

                            alt=""
                        />
                        <p className="letter-heading">{row?.first_name ? row?.first_name?.split(" ")?.find(item => !item.includes('('))?.charAt(0) : ""}{row?.last_name ? row?.last_name?.split(" ")?.find(item => !item.includes('('))?.charAt(0) : ""}</p>
                    </div>
                </TableCell>
                <TableCell className="Decision-maker-userTeblesell_row" align="left" onClick={() => { navigate(`/Profile/${row?.person_id == 0 ? "0" : row?.person_id}`) }} style={{ cursor: 'pointer' }}>
                    <div className="Decision-maker-user-name-main-container">

                        <div className="name-and-title-text">
                            <div className="fullnameofuser">
                                <h3 className="company-name-country">{row?.first_name === "jp" ? "JP" : row?.first_name ? row?.first_name : "-"} {row?.last_name ? row?.last_name : "-"}</h3>
                            </div>


                            <div className="job-title-container">
                                <div className="tooltip-container-jobtitle">
                                    <p className={row?.raw_job_title ? "tooltip-highlights-jobtitle" : "tooltip-highlights-jobtitle-none"}>
                                        {row?.raw_job_title}
                                    </p>
                                    <p className="after-company-name-country-fordecisionmaker">
                                        {row?.primary_job_title?.substring(0, 18) +
                                            (row?.primary_job_title?.length > 18 ? "...." : "")}
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>
                </TableCell>

                <TableCell align="left" style={{ cursor: 'pointer' }}>
                    <h3 className="annual-revenue-table">{row.primary_organization ? row.primary_organization : "-"}</h3>
                </TableCell>
                <TableCell style={{ cursor: 'pointer' }}
                    align="left"
                    className="table-cell-of-contact-details-dropdown-th"
                >
                    <div
                        className="Set-dropdown-ofIndustry"
                        style={{ position: "relative" }}
                    >
                        <div className="email-andrelative-other-info">
                            <div className="maked-component-of-dropdown-forai-leads">
                                <IndustryDropdown row={row} />
                            </div>
                        </div>
                    </div>
                </TableCell>
                <TableCell align="left" style={{ cursor: 'pointer' }}>
                    <div className="Suspect-table-data">
                        <h3 className="industry-sector-table">
                            {row?.suspect_status ? row.suspect_status : "-"}
                        </h3>
                    </div>
                </TableCell>
                <TableCell align="left" className="table-cell-of-contact-details-dropdown-th-prospect" style={{ cursor: 'pointer' }}>
                    <div
                        className="Set-dropdown-ofContactDetailList"
                        style={{ position: "relative" }}
                    >
                        <div className="email-and-other-infodc">
                            <div className="maked-component-of-dropdown">
                                <ContactDetailList item={row} />
                            </div>
                        </div>
                    </div>
                </TableCell>
            </>
            <TableCell className="table-cellhandleRightsidebar-prospect">
                <div className="table-cellhandleRightsidebar" style={{ display: "flex", justifyContent: "flex-end" }}>
                    <IconButton
                        aria-label="expand row"
                        size="small"
                        className="button-collapse-table-propect"
                    >
                        <RightSidebar
                            dataShortestPath={dataShortestPath}
                            openSidebar={openSidebar}
                            userDetails={userDetails}
                            handleRightsidebar={handleRightsidebar}
                            rowid={row}
                        />
                    </IconButton>
                </div>
            </TableCell>

            <TableCell
            >
                <td className="confience-score-icons"> {/* Ensures proper positioning */}
                    <div className="hover-container-prospects">
                        <img src={hoveridentifier} alt="" className="hover-image-prospects" />

                        <div
                            className={`hover-content-prospects ${(!row?.updated_at || !row?.confidence_score) ? "no-update-prospects" : "has-update-prospects"
                                }`}
                        >
                            <div className="data-sync-c-rate-prospects">
                                <div className="datasync-line-c-score-prospects">
                                    <span className="datasync-line-prospects">Data Sync: </span>
                                    <span className="datasync-line-data-prospects">
                                        {row?.updated_at
                                            ? moment(row.updated_at).format("MM.DD.YY")
                                            : "No update information available"}
                                    </span>
                                </div>
                                <div className="datasync-line-c-score-prospects">
                                    <span className="datasync-line-prospects">Data Confidence Score:</span>
                                    <span className="datasync-line-data-prospects">
                                        {row?.confidence_score
                                            ? getConfidenceScore(row.confidence_score)
                                            : "No update information available"}
                                    </span>
                                </div>
                            </div>
                        </div>

                    </div>
                </td>

            </TableCell >
        </TableRow>
    );
}
Row.propTypes = {
    row: PropTypes.object.isRequired,
    selected: PropTypes.bool.isRequired,
    onSelect: PropTypes.func.isRequired,
    connectionStrength: PropTypes.string.isRequired,
};
export default function PeopleSearchResultsTable({
    isSalesForceTrigger, setIsSalesForceTrigger,
    archiveRecord, setArchiveRecord, loading,
    requestUpdateRecord, setRequestUpdateRecord, setDisableRequestUpdate,
    setLoading, trackRecord, setTrackRecord, selectedOuterRows, addToFav, setAddToFav,
    setSelectedOuterRows, setShowSalesForce, trackingData, handleTrackingdata, setIsDecisionMakerExcel, isDecisionMakerExcel, totalCount, setTotalCount }) {
    const location = useLocation();
    const userInfo = GetOktaAuthData();
    const loggedUser = userInfo?.user?.profile;
    const [selectedRows, setSelectedRows] = React.useState([]);
    const [rowsSelect, setRowsSelect] = React.useState({});
    const [searchResultList, setSearchResultList] = React.useState([])
    const loggedInUserId = GetUserId();

    const [hitApi, setHitApi] = React.useState(false)
    const [rowsSelectAll, setRowsSelectAll] = React.useState(false)
    const [messageModal, setMessageModal] = React.useState(false)
    const [messageModalTrack, setMessageModalTrack] = React.useState(false)
    const [messageModalSalesforce, setMessageModalSalesforce] = React.useState(false)
    const [sortOrder, setSortOrder] = React.useState(null);
    const [sortField, setSortField] = React.useState("");
    const [skip, setSkip] = React.useState(0)
    const prevLocationState = React.useRef(location.state);
    const [query, setQuery] = React.useState(location.state);
    const [openCreateListmdl, setOpenCreateListmdl] = React.useState(false);
    const [requestUpdateModal, setRequestUpdateModal] = React.useState(false)

    const style = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 450,
        bgcolor: "background.paper",
        boxShadow: 24,
        borderRadius: "8px",
    };
    const [successModel, setSuccessModel] = React.useState("");


    React.useEffect(() => {
        if (location.state !== prevLocationState.current) {
            setSearchResultList([]);
        }
        prevLocationState.current = location.state;
        setQuery(location.state);
    }, [location.state]);

    //get search results list
    const listPeopleSearchResults = async (isFav) => {
        setLoading(true)
        const options = {
            method: "POST",
            headers: {
                "access-control-allow-origin": "*",
                "content-type": "application/json",
                "X-API-Key": APIUrlToken()
            },
            data: { "people_name": query },
            url: `${APIUrlThree()}/v1/universal_search_people?skip=${skip * 50}&limit=50`,
        };
        try {
            const response = await axios(options);
            setTotalCount(response?.data?.total_records)
            getStrength(response?.data?.data, isFav)
        } catch (error) {
            setLoading(false)
            toast.error(error?.response?.data?.message);
        }
    }
    
    //get conn strength search results list
    const getStrength = async (e, isFav) => {
        const tuples = e.map(item => ({
            items: [loggedInUserId?.toString(), item.person_id?.toString()]
        }));
        const data = { tuples };
        const options = {
            method: "POST",
            headers: {
                "access-control-allow-origin": "*",
                "content-type": "application/json",
                "X-API-Key": APIUrlToken()
            },
            data: data,
            url: `${APIUrlTwo()}/v1/conn_strength`,
        };
        try {
            const response = await axios(options);
            const strengthData = response?.data
            const updatedData = e?.map((item, index) => ({
                ...item,
                strengthData: strengthData[index]
            }));
            if (isFav) {
                setSearchResultList([...updatedData]);
                setSortField("")
            } else {
                setSearchResultList([...searchResultList, ...updatedData]);

            }
            setLoading(false)
        } catch (error) {
            toast.error(error?.response?.data?.message);
        } finally {
        }
    }
    //sort search results list
    const handleSort = (field) => {
        let newSortOrder;
        if (sortField === field) {
            newSortOrder = sortOrder === "asc" ? "desc" : "asc";
        } else {
            newSortOrder = "asc";
        }
        setSortOrder(newSortOrder);
        setSortField(field);

        const sortedData = [...searchResultList].sort((a, b) => {
            let aValue = field.includes(".")
                ? field.split(".").reduce((acc, key) => acc?.[key], a)
                : a[field];
            let bValue = field.includes(".")
                ? field.split(".").reduce((acc, key) => acc?.[key], b)
                : b[field];

            // Handling empty values (null, "", "-") by assigning them a high sorting weight
            const isEmpty = (val) => val === null || val === "" || val === "-";
            const aIsEmpty = isEmpty(aValue);
            const bIsEmpty = isEmpty(bValue);

            if (aIsEmpty && !bIsEmpty) return 1; // Move `a` to last
            if (!aIsEmpty && bIsEmpty) return -1; // Move `b` to last
            if (aIsEmpty && bIsEmpty) return 0;  // Maintain order if both are empty

            // Handle date sorting
            if (field === "updated_at") {
                aValue = new Date(aValue);
                bValue = new Date(bValue);
            }

            // Handle number sorting
            if (typeof aValue === "number" && typeof bValue === "number") {
                return newSortOrder === "asc" ? aValue - bValue : bValue - aValue;
            }

            // Handle string sorting
            if (typeof aValue === "string" && typeof bValue === "string") {
                return newSortOrder === "asc"
                    ? aValue.localeCompare(bValue)
                    : bValue.localeCompare(aValue);
            }

            // Handle date sorting (fallback)
            if (aValue instanceof Date && bValue instanceof Date) {
                return newSortOrder === "asc" ? aValue - bValue : bValue - aValue;
            }

            return 0; // Default case
        });

        setSearchResultList(sortedData);
    };
    // search results list first render sorting
    React.useEffect(() => {
        const sortedDataDefault = searchResultList
            ?.sort((a, b) => {
                if (a.decision_maker && !b.decision_maker) return -1;
                if (!a.decision_maker && b.decision_maker) return 1;
                return (b.strengthData?.strength || 0) - (a.strengthData?.strength || 0);
            });
        setSearchResultList(sortedDataDefault);
    }, [searchResultList]);
    // pagination 
    const loadMore = () => {
        setLoading(true);
        setSkip(prev => prev + 1);
        setTimeout(() => {
            setLoading(false);
        }, 1000);
    };
    // call list method for search results
    React.useEffect(() => {
        listPeopleSearchResults()
    }, [skip, query])
    //select rows
    const handleRowSelect = (row) => {
        setSelectedOuterRows(prevSelectedRows => {
            const isAlreadySelected = prevSelectedRows.some(item => item.person_id === row.person_id);

            if (isAlreadySelected) {
                return prevSelectedRows.filter(item => item.person_id !== row.person_id);
            } else {
                return [...prevSelectedRows, row];
            }
        });
    };
    //select All rows
    React.useEffect(() => {
        if (rowsSelectAll) {
            const allRows = [...searchResultList];
            setSelectedOuterRows(allRows);
        } else if (rowsSelectAll === false) {
            setSelectedOuterRows([]);
        } else if (selectedOuterRows?.length == searchResultList?.length) {
            setRowsSelectAll(true)
        } else if (selectedOuterRows?.length < searchResultList?.length) {
            setRowsSelectAll(false)
        }
    }, [rowsSelectAll, rowsSelect]);
    // check whether there are some selected rows
    React.useEffect(() => {
        if (selectedOuterRows?.length) {
            setHitApi(true)
        } else {
            setHitApi(false)
        }
    }, [selectedOuterRows])


    //remove favorite if you want it to archive
    const handleRemoveFavouriteLead = (row) => {
        // setLoading(true)
        // const data = searchResultList?.find(item => item?.person_id == row?.person_id)
        // const option = {
        //     method: "POST",
        //     headers: {
        //         "access-control-allow-origin": "*",
        //         "content-type": "application/json",
        //         "X-API-Key": APIUrlToken()
        //     },
        //     url: `${APIUrlThree()}/v1/remove_favourite_prospect?id=${data?.favourites_id}`,
        // };
        // axios(option)
        //     .then(async (response) => {
        //         setLoading(false);
        //     })
        //     .catch(() => {
        //         setLoading(false);
        //     });
    }
    //archive records
    const handleArchiveRecords = async () => {
        setLoading(true)
        if (!selectedOuterRows?.length) {
            toast.error("Please select records to archive")
            setArchiveRecord(false)
            return
        } else {
            await Promise.all(selectedOuterRows.map(i => handleRemoveFavouriteLead(i)));
            const data = selectedOuterRows.map(item => ({
                user_id: Number(GetUserId()),
                people_id: item?.person_id
            }));

            const options = {
                method: "POST",
                headers: {
                    "access-control-allow-origin": "*",
                    "content-type": "application/json",
                    "X-API-Key": APIUrlToken()
                },
                data: data,
                url: `${APIUrlThree()}/v1/send_archive`,
            };
            try {
                const response = await axios(options);
                setMessageModal(false)
                setArchiveRecord(false)
                setSelectedOuterRows([])
                if (response?.data?.message === "Already archived") {
                    toast.success("Prospects already Archived.")
                } else {
                    listPeopleSearchResults(true)
                    toast.success("Prospects Archived Successfully")
                }
                setLoading(false)

            } catch (error) {
                setLoading(false)
                toast.error(error?.response?.data?.message);

            } finally {
            }
        }
    }
    React.useEffect(() => {
        if (archiveRecord == true) {
            if (hitApi == true) {
                setMessageModal(true)
                setArchiveRecord(false)
            } else {
                toast.error("Please select record to archive.")
            }
        }
    }, [archiveRecord])
    //track records 
    const handleTrackRecords = () => {
        if (!selectedOuterRows?.length) {
            toast.error("Please select records to track")
            setTrackRecord(false)
            return
        } else {
            setLoading(true);
            const filteredData = selectedOuterRows.filter((selectedItem) =>
                !trackingData.some(
                    (trackingItem) => Number(selectedItem.person_id) === Number(trackingItem.person_id)
                )
            );

            if (filteredData.length === 0) {
                toast.error("All selected records are already tracked.");
                setLoading(false);
                return;
            }

            const data = filteredData.map(item => item?.person_id);
            // const data = selectedOuterRows.map(item => item?.person_id);
            const option = {
                method: "POST",
                headers: {
                    "access-control-allow-origin": "*",
                    "X-API-Key": APIUrlToken()
                },
                data: data,
                url: `${APIUrlThree()}/v1/save_tracking_prospect?user_id=${Number(GetUserId())}`,
            };
            axios(option)
                .then((response) => {
                    if (response.status === 200) {
                        setLoading(false);
                        setTrackRecord(false)
                        setSelectedOuterRows([])
                        setMessageModalTrack(false)
                        handleTrackingdata();
                        toast.success("Tracking Added")
                    }
                })
                .catch((error) => {
                    setLoading(false);
                    toast.error(error.response.data.message);
                });
        }
    }

    React.useEffect(() => {
        if (trackRecord === true) {
            if (!selectedOuterRows?.length) {
                toast.error("Please select records to track");
                setTrackRecord(false);
                return;
            } else if (hitApi === true) {
                setMessageModalTrack(true);
                setTrackRecord(false);
            }
        }
    }, [trackRecord]);

    // Push to salesforce start
    const validateSalesforce = () => {
        if (!selectedOuterRows || selectedOuterRows?.length === 0) {
            toast.error("Please Select Records For Push To Salesforce");
            setIsSalesForceTrigger(false)
            return false;
        }
        return true;
    };

    React.useEffect(() => {
        if (isSalesForceTrigger) {
            if (!validateSalesforce()) return;
            if (hitApi == true) {
                setMessageModalSalesforce(true)
            }
        }
    }, [isSalesForceTrigger]);

    React.useEffect(() => {
        if (selectedOuterRows?.length) {
            const data = selectedOuterRows?.filter((item) => item.suspect_status !== null)
            if (data?.length) {

                setShowSalesForce("disable")
            } else {
                setShowSalesForce("show")
            }
        } else {
            setShowSalesForce(false)
        }
    }, [selectedOuterRows])
    // Push to salesforce end


    //add to favorite
    React.useEffect(() => {
        if (addToFav == true) {
            if (!selectedOuterRows?.length) {
                toast.error("Please select records to Add To Favorites")
                setAddToFav(false)
                return
            }
            setOpenCreateListmdl(true)
            setAddToFav(false)

            // handleTrackRecords()
        }
    }, [addToFav])

    //download excel
    React.useEffect(() => {
        if (isDecisionMakerExcel) {
            if (!selectedOuterRows?.length) {
                toast.error("Please select records to download");
                setIsDecisionMakerExcel(false);
                return
            }
            exportToExcel(selectedOuterRows, 'people_search_results_exported_data');
        }
    }, [isDecisionMakerExcel])
    const exportToExcel = (data, filename) => {
        const filteredData = data.map(({ person_id, org_id, strengthData, ...rest }) => rest);
        const ws = XLSX.utils.json_to_sheet(filteredData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
        XLSX.writeFile(wb, `${filename}.xlsx`);
        setIsDecisionMakerExcel(false);
    };

    React.useEffect(() => {
        if (selectedOuterRows?.length < 1 && requestUpdateRecord == true) {
            setDisableRequestUpdate(false)
            setRequestUpdateRecord(false)
            toast.error("Please select record to request update")
            return
        } else if (selectedOuterRows?.length === 1 && requestUpdateRecord == true) {
            setRequestUpdateModal(true)
            setRequestUpdateRecord(false)
            setDisableRequestUpdate(false)
        } else if (selectedOuterRows?.length > 1 && requestUpdateRecord == true) {
            setDisableRequestUpdate(false)
            setRequestUpdateRecord(false)
            toast.error("Please select only one record to request update")
        } else {
            setDisableRequestUpdate(false)
        }
    }, [selectedOuterRows, requestUpdateRecord])
    return (
        <>
            {
                searchResultList?.length ?
                    <TableContainer component={Paper} className="ai-leads-table-main">
                        <Table aria-label="collapsible table" className="ai-leads-table">
                            <TableHead>
                                <TableRow className="table-row-ai-leads">
                                    <TableCell className="score-row-table">Select</TableCell>
                                    <TableCell className="score-row-table favorite_col_star">Favorite</TableCell>
                                    <TableCell align="left" className="DecisionstableStrengthnewclass">
                                        <p className="DecisionstableStrength-strength">
                                            JOI Strength{""}
                                            {sortField === "strengthData.strength" ? (
                                                sortOrder === "asc" ? (
                                                    <NorthIcon
                                                        className="up-down-arrows-sorting"
                                                        onClick={() => handleSort("strengthData.strength")}
                                                    />
                                                ) : (
                                                    <SouthIcon
                                                        className="up-down-arrows-sorting"
                                                        onClick={() => handleSort("strengthData.strength")}
                                                    />
                                                )
                                            ) : (
                                                <img
                                                    src={sortingimg}
                                                    alt=""
                                                    onClick={() => handleSort("strengthData.strength")}
                                                    className="sorting-arrow-leadsprofile"
                                                    style={{ cursor: "pointer" }}
                                                />
                                            )}

                                        </p>
                                    </TableCell>
                                    <TableCell className="Decisions-row-tableName-prospect">
                                    </TableCell>
                                    <TableCell className="Decisions-row-tableName">
                                        <p className="prospect-Name-and-Title-prospect">
                                            Name & Title {""}
                                            {sortField === "first_name" ? (
                                                sortOrder === "asc" ? (
                                                    <NorthIcon
                                                        className="up-down-arrows-sorting"
                                                        onClick={() => handleSort("first_name")}
                                                    />
                                                ) : (
                                                    <SouthIcon
                                                        className="up-down-arrows-sorting"
                                                        onClick={() => handleSort("first_name")}
                                                    />
                                                )
                                            ) : (
                                                <img
                                                    src={sortingimg}
                                                    alt=""
                                                    onClick={() => handleSort("first_name")}
                                                    className="sorting-arrow-leadsprofile"
                                                    style={{ cursor: "pointer" }}
                                                />
                                            )}
                                        </p>
                                    </TableCell>

                                    <TableCell align="left" className="employee-row-tableCompany">
                                        <p className="DecisionstableStrength-companynew">  Organization{" "}

                                            {sortField === "primary_organization" ? (
                                                sortOrder === "asc" ? (
                                                    <NorthIcon
                                                        className="up-down-arrows-sorting"
                                                        onClick={() => handleSort("primary_organization")}
                                                    />
                                                ) : (
                                                    <SouthIcon
                                                        className="up-down-arrows-sorting"
                                                        onClick={() => handleSort("primary_organization")}
                                                    />
                                                )
                                            ) : (
                                                <img
                                                    src={sortingimg}
                                                    alt=""
                                                    onClick={() => handleSort("primary_organization")}
                                                    className="sorting-arrow-leadsprofile"
                                                    style={{ cursor: "pointer" }}
                                                />
                                            )}

                                        </p>
                                    </TableCell>
                                    <TableCell align="left" className="annual-row-tableIndustry">
                                        <p>
                                            Industry/ Sector{" "}

                                            {sortField === "categories" ? (
                                                sortOrder === "asc" ? (
                                                    <NorthIcon
                                                        className="up-down-arrows-sorting"
                                                        onClick={() => handleSort("categories")}
                                                    />
                                                ) : (
                                                    <SouthIcon
                                                        className="up-down-arrows-sorting"
                                                        onClick={() => handleSort("categories")}
                                                    />
                                                )
                                            ) : (
                                                <img
                                                    src={sortingimg}
                                                    alt=""
                                                    onClick={() => handleSort("categories")}
                                                    className="sorting-arrow-leadsprofile"
                                                    style={{ cursor: "pointer" }}
                                                />
                                            )}
                                        </p>
                                    </TableCell>

                                    <TableCell align="left" className="industry-row-tableStatus">
                                        <p className="DecisionstableStrength-strength"> JOSF Status{""}

                                            {sortField === "suspect_status" ? (
                                                sortOrder === "asc" ? (
                                                    <NorthIcon
                                                        className="up-down-arrows-sorting"
                                                        onClick={() => handleSort("suspect_status")}
                                                    />
                                                ) : (
                                                    <SouthIcon
                                                        className="up-down-arrows-sorting"
                                                        onClick={() => handleSort("suspect_status")}
                                                    />
                                                )
                                            ) : (
                                                <img
                                                    src={sortingimg}
                                                    alt=""
                                                    onClick={() => handleSort("suspect_status")}
                                                    className="sorting-arrow-leadsprofile"
                                                    style={{ cursor: "pointer" }}
                                                />
                                            )}
                                        </p>
                                    </TableCell>
                                    <TableCell
                                        align="left"
                                        className="prospects-row-tableDetails-cd">
                                        <p className="Com-details-prospect">  Contact Details</p>
                                    </TableCell>
                                    <TableCell
                                        // align="left"
                                        className="prospects-row-tableDetails-cd">
                                    </TableCell>
                                    <TableCell>
                                        {sortField === "updated_at" ? (
                                            sortOrder === "asc" ? (
                                                <NorthIcon
                                                    className="sync-sorting-img-d-maker"
                                                    onClick={() => handleSort("updated_at")}
                                                />
                                            ) : (
                                                <SouthIcon
                                                    className="sync-sorting-img-d-maker"
                                                    onClick={() => handleSort("updated_at")}
                                                />
                                            )
                                        ) : (
                                            <img
                                                src={syncsorting}
                                                alt=""
                                                onClick={() => handleSort("updated_at")}
                                                className="sync-sorting-img"
                                            />
                                        )}
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {searchResultList
                                    ?.sort((a, b) => {
                                        if (a.decision_maker === b.decision_maker) {
                                            return 0;
                                        }
                                        return a.decision_maker ? -1 : 1;
                                    })
                                    .map((row, index) => (
                                        <React.Fragment key={index}>
                                            <Row
                                                row={row}
                                                selected={selectedRows.includes(row)}
                                                onSelect={(firstName) => {
                                                    const selectedIndex = selectedRows.indexOf(firstName);
                                                    let newSelected = [];
                                                    if (selectedIndex === -1) {
                                                        newSelected = newSelected.concat(selectedRows, firstName);
                                                    } else if (selectedIndex === 0) {
                                                        newSelected = newSelected.concat(selectedRows.slice(1));
                                                    } else if (selectedIndex === selectedRows.length - 1) {
                                                        newSelected = newSelected.concat(selectedRows.slice(0, -1));
                                                    } else if (selectedIndex > 0) {
                                                        newSelected = newSelected.concat(
                                                            selectedRows.slice(0, selectedIndex),
                                                            selectedRows.slice(selectedIndex + 1)
                                                        );
                                                    }
                                                    setSelectedRows(newSelected);
                                                }}
                                                connectionStrength={row.connectionStrength}
                                                setLoading={setLoading}
                                                setRowsSelect={setRowsSelect}
                                                selectedOuterRows={selectedOuterRows}
                                                searchResultList={searchResultList}
                                                setSearchResultList={setSearchResultList}
                                                listPeopleSearchResults={listPeopleSearchResults}
                                                handleRowSelect={handleRowSelect}
                                            />
                                        </React.Fragment>
                                    ))}

                            </TableBody>
                        </Table>
                    </TableContainer> :
                    <div className="ai-leads-table-main">
                        <div className="ai-leads-no-data-available-outter">
                            <div className="ai-leads-no-data-available">
                                No Data Available
                            </div>
                        </div>
                    </div>
            }
            <div className="loadmore-pagination-section">
                {totalCount !== searchResultList?.length && <button className="btn-load-more button-loadmore-pagination" onClick={loadMore} disabled={loading}>{loading ? 'Loading...' : 'Load More'}</button>}
            </div>
            <MessageModal open={messageModal}
                setOpen={setMessageModal} message={`Are you sure that you want to archive ${selectedOuterRows?.length > 1 ? "these records" : "this record"}?`}
                handleSubmit={handleArchiveRecords}
                listPeopleSearchResults={() => listPeopleSearchResults(true)} length={selectedOuterRows?.length} />
            <MessageModal open={messageModalTrack} setOpen={setMessageModalTrack} message={`Are you sure that you want to add ${selectedOuterRows?.length > 1 ? "these records" : "this record"} to tracking?`} handleSubmit={handleTrackRecords} length={selectedOuterRows?.length} />
            {/* <MessageModal open={messageModalSalesforce} setOpen={setMessageModalSalesforce} message={`Are you sure that you want to push ${selectedOuterRows?.length > 1 ? "these records" : "this record"} to Salesforce?`} handleSubmit={pushToSalesForce} length={selectedOuterRows?.length} /> */}
            <SalesForceMessageModal open={messageModalSalesforce} setOpen={setMessageModalSalesforce} selectedOuterRows={selectedOuterRows} setSelectedOuterRows={setSelectedOuterRows} setIsSalesForceTrigger={setIsSalesForceTrigger} decisionMakerData={searchResultList} setLoading={setLoading} />

            <AddToFavoritePeopleModal open={openCreateListmdl} setOpen={setOpenCreateListmdl}
                selectedOuterRows={selectedOuterRows}
                message={`Are you sure that you want to add ${selectedOuterRows?.length > 1 ? "these records" : "this record"} to Favorites?`}
                handlePassSubmit={() => listPeopleSearchResults(true)}
                setSelectedOuterRows={setSelectedOuterRows}
            />
            <ProspectRequestModal requestUpdateRecord={requestUpdateModal}
                setRequestUpdateRecord={setRequestUpdateModal}
                profileData={selectedOuterRows[0]} setSuccessModel={setSuccessModel}
                successModel={successModel}
                peopleId={selectedOuterRows?.[0]?.person_id} setSelectedOuterRows={setSelectedOuterRows} />
            <Modal
                open={successModel == true}
                onClose={() => setSuccessModel(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <div className="vrufyerv">
                    <Box sx={style} style={{ overflowY: "auto", width: "30%", }}>
                        <div className='de_pad_req-up'>
                            <p className='cross-people-req-model'><ClearIcon onClick={() => setSuccessModel(false)} /></p>
                            <p className='de_head'>Your Record Update request has been successfully submitted. The JOI team will review your request and notify you when the record has been updated.</p>
                        </div>
                    </Box>
                </div>
            </Modal>
        </>
    );
}

Row.propTypes = {
    row: PropTypes.object.isRequired,
    selected: PropTypes.bool.isRequired,
    onSelect: PropTypes.func.isRequired,
    connectionStrength: PropTypes.string.isRequired,
};
